// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "BadgeTooltip" + "." + "a3080e5829e17f41" + ".js"
}